export default {
  careersPaginated: (state) => state.careersPaginated,
  careerItem: (state) => state.careerItem,
  careerColumnsNames:(state) => state.careerColumnsNames
};
